import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { downloadFile } from '@/common/utils/downloadFile'

import { exportPartnerPlayersCsv } from '../../services'

import type { ExportPartnerPlayersCsvRequest } from '../../../type'

type ExportParams = {
	partnerId: string
	payload: ExportPartnerPlayersCsvRequest
}

export function useMutationExportPartnerPlayersCsv() {
	return useMutation({
		mutationFn: async ({ partnerId, payload }: ExportParams) => {
			return await exportPartnerPlayersCsv(partnerId, payload)
		},
		onSuccess: (blob) => {
			const timestamp = new Date().toISOString().split('T')[0]
			const isZip =
				blob.type === 'application/zip' ||
				blob.type === 'application/x-zip-compressed'

			downloadFile({
				blob,
				defaultFilename: `partner_players_export_${timestamp}`,
			})

			toast.success(
				isZip ? 'ดาวน์โหลดไฟล์ ZIP สำเร็จ' : 'ดาวน์โหลดไฟล์ CSV สำเร็จ',
			)
		},
		onError: (error) => {
			console.error('CSV export error:', error)
			toast.error('การดาวน์โหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}
